<app-header></app-header>

<div id="page-content-with-footer">
  <div id="page-content-container">
    <router-outlet></router-outlet>
  </div>
  <corteva-footer></corteva-footer>
</div>
